import parse from "html-react-parser";
import { baseUrl } from "../../../../../../utils";
import IconComponent from "../IconComponent";

const AccountProfileCard = ({ title, description, icon, showButton = false, link = null }) => {
  return (
    <div className="col-lg-6 col-md-6">
      <div className="card card-custom mb-4 bgi-no-repeat" style={{ backgroundPosition: "right top", backgroundSize: "30% auto", backgroundImage: `url(${baseUrl('svg/abstract-1.svg')})`, }} >
        <div className="card-body p-3">
          <div className="d-flex align-items-center">
            <div className="me-3">
              <IconComponent>{icon}</IconComponent>
            </div>

            <div className="d-flex flex-column">
              <h6 className="mb-2 text-gradient">{title}</h6>
              <div className="d-flex align-items-center justify-content-between">
                <div className="text-dark-75"> <span id="stripeLastDigits">{description || 'Not availabe in Your Plan'}</span> </div>
                {showButton ? <a id="checkout-button" target="_blank" className="ladda-button submitButton font-weight-bold btn btn-primary btn-sm btn-pill" href={link} > Update card{" "} </a> : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AccountProfileCard;
